import React, { ChangeEvent, useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import CompanyName from '../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import Decision from '../../commonComponents/Decision';
import { DecisionType } from '../../../static/types/commonTypes/decisionType';
import LegalEntity from '../../commonComponents/LegalEntity';
import DateComponent from '../../commonComponents/DateComponent';
import { DateType } from '../../../static/types/commonTypes/dateType';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import DecisionWithQuality from '../../commonComponents/DecisionWithQuality';
import { formatObjectText } from '../../../utils/functions/formatObjectText';


interface AnnonceProps {
    txtAnnonce: string;
    denomination: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    activeIndex: number;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    updatesocieteSelected: (newTxt: string) => void;
    societeSelected: string;
}

const ChangementDureeSocial: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,

}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        decisionWithQualityAndEffectiveDate,
        setDecisionWithQualityAndEffectiveDate,
        decisionWithQualityAndEffectiveDateValidity,
        setDecisionWithQualityAndEffectiveDateValidity,
        decisionWithQualityAndEffectiveDateChecked,
        setDecisionWithQualityAndEffectiveDateChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

        date, setDate,
        dateValidity, setDateValidity,
        dateChecked, setDateChecked,

        lastTab, setLastTab

    } = useAppContext() as AppContextType


    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];
    const [submissive, setSubmissive] = useState<boolean>(false)
    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);

    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    // Soumettre le formulaire
    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName')
        }
        else if (!decisionWithQualityAndEffectiveDateValidity) {
            setActiveTab('decision')
        }
        else if (!legalEntityValidity) {
            setActiveTab('theSociety')
        }
        else if (!dateValidity) {
            setActiveTab('companyExpirationDate')
        }

        return companyNameValidity && decisionWithQualityAndEffectiveDateValidity && legalEntityValidity && dateValidity
    };

    const handleSubmit = (event: ChangeEvent<HTMLFormElement>) => {
        event.preventDefault()

        const valid = validate()

        if (valid) {
            const pluralSubjects = ["Les associés","Les actionnaires"];

            const verb = pluralSubjects.includes(decisionWithQualityAndEffectiveDate.decisionQuality) ? "ont" : "a";
            const decisionNature = decisionWithQualityAndEffectiveDate.decisionNature === "AG Extraordinaire"
                ? "l'AGE"
                : decisionWithQualityAndEffectiveDate.decisionNature === "AG Ordinaire"
                    ? "l'AGO"
                    : decisionWithQualityAndEffectiveDate.decisionNature === "AG Mixte"
                        ? "l'AG Mixte"
                        : decisionWithQualityAndEffectiveDate.decisionNature

            const decisionText = firstPartDecision.includes(decisionWithQualityAndEffectiveDate.decisionNature)
                ? `Aux termes de ${decisionNature} en date du ${decisionWithQualityAndEffectiveDate.decisionDate} ${decisionWithQualityAndEffectiveDate.decisionQuality} ${verb} ${decisionWithQualityAndEffectiveDate.effectiveDate ? ` décidé de proroger la durée jusqu'au ${date.date} à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}` : ``}`
                : `Le ${decisionWithQualityAndEffectiveDate.decisionDate}, ${decisionNature.toLowerCase()} ${verb} ${decisionWithQualityAndEffectiveDate.effectiveDate ? `décidé de proroger la durée jusqu'au ${date.date} à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}` : ``}`

            const tempText = `${legalEntity.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €,
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)}
${decisionText},
Mention au RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName)
            setSubmissive(true)
        }
    }

    const switchTab = (tab: string) => {
        if (!visitedTabs.includes(tab)) setVisitedTabs([...visitedTabs, tab]);
        setActiveTab(tab);
    };

    const handleNext = () => {
        if (activeTab === 'companyName') {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab('companyName'))
            }
        } else if (activeTab === 'decision') {
            setDecisionWithQualityAndEffectiveDateChecked(true)
            if (decisionWithQualityAndEffectiveDateValidity) {
                switchTab(getNextTab('decision'))
            }
        } else if (activeTab === 'theSociety') {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab('theSociety'))
            }
        } else if (activeTab === 'companyExpirationDate') {
            setDateChecked(true)
            if (dateValidity) {
                setSubmissive(true)
            }
        }
    };


    const goToSupportPresse = () =>  updateActiveIndex(2); 
    
    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };
        
    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['companyName', 'decision', 'theSociety', 'companyExpirationDate'];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);

    const getNextTab = (currentTab: string) => {
        switch (currentTab) {
            case 'companyName':
                return 'decision';
            case 'decision':
                return 'theSociety';
            case 'theSociety':
                return 'companyExpirationDate';
            default:
                return currentTab;
        }
    };

    const getPreviousTab = (currentTab: string) => {
        switch (currentTab) {
            case 'companyExpirationDate':
                return 'theSociety';
            case 'theSociety':
                return 'decision';
            case 'decision':
                return 'companyName';
            default:
                return currentTab;
        }
    };

    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQualityAndEffectiveDate({ ...decisionWithQualityAndEffectiveDate, ...data });

    const tabs = [
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'decision', label: "Choisir l'organe et la date de la décision"},
        {key: 'theSociety', label: 'La société'},
        {key: 'companyExpirationDate', label: "Date d'expiration de la société"},
    ]
    return (
        <>

                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>
            <ToastContainer />

            <form onSubmit={handleSubmit}>

                {
                    activeTab === 'companyName' &&
                    <CompanyName
                        changeCompanyName={(partialCompanyName: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...partialCompanyName })}
                        checked={companyNameChecked}
                        companyName={companyName}
                        onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                    />
                }

                {
                    activeTab === 'decision' &&
                    <DecisionWithQuality
                        decisionWithQuality={decisionWithQualityAndEffectiveDate}
                        draftFieldName = 'decisionWithQualityAndEffectiveDate'
                        checked={decisionWithQualityAndEffectiveDateChecked}
                        dateLabel='Date'
                        changeDecision={updateDecision}
                        onValidationChange={(isValid: boolean) => setDecisionWithQualityAndEffectiveDateValidity(isValid)}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }

                {
                    activeTab === 'theSociety' &&
                    <LegalEntity
                        changeLegalEntity={(partialData: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...partialData })}
                        checked={legalEntityChecked}
                        legalEntity={legalEntity}
                        onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                        companyName={companyName}
                        setCompanyName={(partialData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...partialData })}
                        societyType={societyTypeOptions}
                        draftFieldName = 'legalEntity'
                    />
                }

                {
                    activeTab === 'companyExpirationDate' &&
                    <>
                        <div className="me-2">
                            <DateComponent
                                id='dateExpiration'
                                changeDate={(partialData: Partial<DateType>) => setDate({ ...date, ...partialData })}
                                checked={dateChecked}
                                date={date}
                                draftFieldName = 'date'
                                dateLabel="Date d'expiration"
                                required={true}
                                onValidationChange={(isValid: boolean) => setDateValidity(isValid)}
                            />
                        </div>

                        {
                            submissive &&
                            <div className="mt-4">
                                <h4>Texte de l'annonce:</h4>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    value={txtAnnonce}
                                    disabled
                                />
                            </div>
                        }
                    </>
                }

                <div className='button-container'>
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious} >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }

                        {
                            activeTab === 'companyExpirationDate' &&
                            <button type="submit" onClick={handleNext}>Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            activeTab !== 'companyExpirationDate' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext} >
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            submissive && activeTab === 'companyExpirationDate' &&
                            <button color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse} >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>

                        }

                    </div>
                </div>

            </form>
        </>
    );
};
export default ChangementDureeSocial;